export default "__VITE_ASSET__nJ$Q_Zar__"